import type { CellWidgetProvideConfig } from '@delon/abc/cell';

export const CELL_WIDGETS: CellWidgetProvideConfig[] = [];
